export default __webpack_public_path__ + "static/media/logouticondark.f79ab1e9.svg";